<h1 mat-dialog-title>Quote Request</h1>
<form mat-dialog-content novalidate [formGroup]="form">
  <mat-form-field color="accent" appearance="outline" [floatLabel]="usersName() ? 'always' : 'auto'">
    <mat-label>Name</mat-label>
    <input matInput [placeholder]="usersName() || 'Name'" formControlName="name" [required]="!usersName()" />
  </mat-form-field>

  <mat-form-field color="accent" appearance="outline" [floatLabel]="usersEmail() ? 'always' : 'auto'">
    <mat-label>Email</mat-label>
    <input matInput [placeholder]="usersEmail() || 'Your email'" formControlName="email" [required]="!usersEmail()" />
  </mat-form-field>

  <mat-form-field color="accent" appearance="outline">
    <mat-label>Request</mat-label>
    <textarea matInput placeholder="How can we help?" formControlName="message"></textarea>
  </mat-form-field>

  <h3>Quote Items</h3>
  @let displayCols = ["manufacturer", "partNumber", "description", "quantity", "tool"];

  <table mat-table [dataSource]="itemData()" class="mat-elevation-z8" formArrayName="items">
    <!-- Part Number Column -->
    <ng-container matColumnDef="partNumber">
      <th mat-header-cell *matHeaderCellDef>Part Number</th>
      <td mat-footer-cell *matFooterCellDef></td>
      <td mat-cell *matCellDef="let element; let i = index">
        <mat-form-field appearance="outline" [formGroupName]="i">
          <input matInput formControlName="partNumber" placeholder="Part Number" />
        </mat-form-field>
      </td>
    </ng-container>
    <!-- Description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef>Description</th>
      <td mat-footer-cell *matFooterCellDef></td>
      <td mat-cell *matCellDef="let element; let i = index">
        <mat-form-field appearance="outline" [formGroupName]="i">
          <input matInput formControlName="description" placeholder="Description" />
        </mat-form-field>
      </td>
    </ng-container>
    <!-- Manufacturer Column -->
    <ng-container matColumnDef="manufacturer">
      <th mat-header-cell *matHeaderCellDef>Manufacturer</th>
      <td mat-footer-cell *matFooterCellDef></td>
      <td mat-cell *matCellDef="let element; let i = index">
        <mat-form-field appearance="outline" [formGroupName]="i">
          <input matInput formControlName="manufacturer" placeholder="Manufacturer" />
        </mat-form-field>
      </td>
    </ng-container>
    <!-- Quantity Column -->
    <ng-container matColumnDef="quantity">
      <th mat-header-cell *matHeaderCellDef>Quantity</th>
      <td mat-footer-cell *matFooterCellDef></td>
      <td mat-cell *matCellDef="let element; let i = index">
        <mat-form-field appearance="outline" [formGroupName]="i">
          <input matInput formControlName="quantity" placeholder="Quantity" />
        </mat-form-field>
      </td>
    </ng-container>
    <!-- Tool Column -->
    <ng-container matColumnDef="tool">
      <th mat-header-cell *matHeaderCellDef>
        <button mat-icon-button (click)="addItem()"><mat-icon>add</mat-icon></button>
      </th>
      <td mat-footer-cell *matFooterCellDef>
        @if (itemData().length > 4) {
          <button #a mat-icon-button (click)="addItem(); a._elementRef.nativeElement.scrollIntoView()"><mat-icon>add</mat-icon></button>
        }
      </td>
      <td mat-cell *matCellDef="let element; let i = index" [formGroupName]="i">
        <button mat-icon-button (click)="removeItem(i)"><mat-icon>remove</mat-icon></button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayCols"></tr>
    <tr mat-row *matRowDef="let row; columns: displayCols"></tr>
    <tr mat-footer-row *matFooterRowDef="displayCols"></tr>
  </table>

  <h3>Upload FIle/Image</h3>
  <input type="file" (change)="onFileSelected($event)" [accept]="validFileTypes" multiple />

  <div *ngIf="errors.length" class="errors">
    <label>Errors:</label>
    <div *ngFor="let error of errors">
      {{ error }}
    </div>
  </div>
</form>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>Cancel</button>
  <button mat-flat-button [disabled]="form.invalid || loading" color="accent" (click)="onSubmit()">Send Request</button>
</mat-dialog-actions>
